import React from "react";
import GoogleMaps from "../GoogleMaps";
import { makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import Form from "./Form";
import axios from "axios";

const SearchResult = ({ place, onPick }) => (
  <article className="media" key={place.place_id} onClick={onPick}>
    <figure className="media-left">
      <p className="image is-64x64">
        <img src={place.icon} />
      </p>
    </figure>
    <div className="media-content">
      <div className="content">
        <h4>{place.name}</h4>
        {place.vicinity}
      </div>
    </div>
  </article>
);

class NewWalkinEntry extends React.Component {
  location = {};
  located = false;
  searchResults = [];
  searching = false;
  currentPlace = null;
  errors = {};

  constructor(props) {
    super(props);
    this.dummyRef = React.createRef();
    this.searchRef = React.createRef();
    makeObservable(this, {
      location: observable,
      located: observable,
      searchResults: observable,
      searching: observable,
      currentPlace: observable,
      errors: observable
    });
  }

  setupMapCallback() {
    window.mapCallback = () => {
      this.placesService = new google.maps.places.PlacesService(
        this.dummyRef.current
      );
    };
  }

  componentDidMount() {
    this.setupMapCallback();
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(position => {
        this.location = position.coords;
        this.located = true;
      });
    }
  }

  search() {
    var request = {
      keyword: this.searchRef.current.value,
      radius: 2000,
      location: { lat: this.location.latitude, lng: this.location.longitude }
    };

    this.searching = true;

    this.placesService.nearbySearch(request, (results, status, pagination) => {
      this.searching = false;
      this.searchResults = results;
    });
  }

  submit(data, cardFront, cardBack) {
    const formData = new FormData();
    formData.append("card_front", cardFront);
    formData.append("card_back", cardBack);
    formData.append("place", JSON.stringify(data.place));
    formData.append("notes", data.notes);
    formData.append("availability", data.availability);
    formData.append("lat", this.location.latitude);
    formData.append("lng", this.location.longitude);

    axios
      .post("/pro/walk_ins", formData, {
        headers: {
          "content-type": "multipart/form-data"
        }
      })
      .then(() => {
        alert("Success!");
        window.location = "/pro/walk_ins/new";
      })
      .catch(({ response }) => {
        const body = response.data;
        this.errors = body.data;
      });
  }

  pickPlace(place) {
    this.searchResults = [];
    this.currentPlace = place;
  }

  manual() {
    this.currentPlace = {};
    this.searchResults = [];
  }

  render() {
    const disable = !this.located || this.searching;
    return (
      <div>
        {this.located ? "" : "Updating your location..."}
        <div className="field has-addons">
          <input ref={this.dummyRef} type="hidden" />
          <input
            ref={this.searchRef}
            type="text"
            disabled={disable}
            className="input"
          />
          <button
            onClick={this.search.bind(this)}
            disabled={disable}
            className="button is-info"
          >
            Search
          </button>

          <button
            onClick={this.manual.bind(this)}
            disabled={disable}
            className="button is-primary"
          >
            Manual
          </button>
        </div>
        <div id="results">
          {this.searchResults.map(place => (
            <SearchResult
              key={place.place_id}
              place={place}
              onPick={this.pickPlace.bind(this, place)}
            />
          ))}
          {this.currentPlace ? (
            <Form
              place={this.currentPlace}
              onSubmit={this.submit.bind(this)}
              errors={this.errors}
            />
          ) : null}
        </div>
        <GoogleMaps />
      </div>
    );
  }
}

export default observer(NewWalkinEntry);
